module.exports = __webpack_public_path__ + "media/components/country-flag/static/ca-d04a30deb4c7a6829f87200856a05049.svg";